module.exports = __webpack_public_path__ + "img/stripe.b7edbdb5.png";